export const KEYWORDS = [
  {
    label: "Front End",
    searchKeywords: ["frontend", "front end", "front-end"],
  },
  {
    label: "Software Engineer",
    searchKeywords: ["software engineer", "sde", "sde i", "sde-i"],
  },
  {
    label: "Intern",
    searchKeywords: ["intern", "internship"],
  },
  {
    label: "Software Engineer-II",
    searchKeywords: [
      "sde ii",
      "sde-ii",
      "software engineer ii",
      "software engineer-ii",
    ],
  },
  {
    label: "Product",
    searchKeywords: [
      "product",
      "product management",
      "product manager",
      "design",
      "product design",
      "product designer",
    ],
  },
  {
    label: "Machine Learning",
    searchKeywords: [
      "machine learning",
      "ml",
      "mle",
      "deep learning",
      "data science",
      "data scientist",
    ],
  },
  {
    label: "AI Engineer",
    searchKeywords: [
      "ai engineer",
      "ai/ml",
      "artificial intelligence",
      "generative ai",
      "gen ai",
      "llm",
    ],
  },
  {
    label: "Applied Scientist",
    searchKeywords: [
      "applied scientist",
      "applied science",
      "research scientist",
      "research engineer",
    ],
  },
  {
    label: "Forward Deployed",
    searchKeywords: [
      "forward deployed",
      "forward deployed engineer",
      "forward deployed software engineer",
      "fde",
      "fdse",
    ],
  },
  {
    label: "Mobile",
    searchKeywords: ["mobile", "ios", "android", "react native"],
  },
];
